import { render, staticRenderFns } from "./MedicaoEspessuraModal.vue?vue&type=template&id=388cc3fb&scoped=true"
import script from "./MedicaoEspessuraModal.vue?vue&type=script&lang=js"
export * from "./MedicaoEspessuraModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388cc3fb",
  null
  
)

export default component.exports